import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
var _dec, _class, _SessionItemResult;
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
/** @jsx jsx */
/* eslint "jsx-a11y/click-events-have-key-events": "warn" */
import { Component } from 'react';
import PropTypes from 'prop-types';
import ImmutablePropTypes from 'react-immutable-proptypes';
import { Alert } from '@instructure/ui-alerts';
import { Text } from '@instructure/ui-text';
import { Heading } from '@instructure/ui-heading';
import { View } from '@instructure/ui-view';
import { PresentationContent } from '@instructure/ui-a11y-content';
import { jsx } from '@instructure/emotion';
import { RichContentRenderer } from '@instructure/quiz-rce';
import t from '@instructure/quiz-i18n/es/format-message';
import PositionBox from '../../positionBox/PositionBox';
import { COMPONENT_RESULT, withStyleOverrides } from '@instructure/quiz-common';
import componentForItem from '../../../../util/componentForItem';
import CustomPropTypes from '../../../../util/CustomPropTypes';
import keyboardClickable from '../../../../util/keyboardClickable';
import generateStyle from './styles';
import generateComponentTheme from './theme';
export var SessionItemResult = (_dec = withStyleOverrides(generateStyle, generateComponentTheme), _dec(_class = (_SessionItemResult = /*#__PURE__*/function (_Component) {
  function SessionItemResult() {
    var _this;
    _classCallCheck(this, SessionItemResult);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper(this, SessionItemResult, [].concat(args));
    _defineProperty(_this, "getWorkingInstance", function (sessionItemResult) {
      // Check for getWorkingInstance because it does not exist on results page object
      // and is only needed on the grading page
      if (sessionItemResult.getWorkingInstance) {
        return sessionItemResult.getWorkingInstance().toJS();
      }
      return sessionItemResult.toJS();
    });
    return _this;
  }
  _inherits(SessionItemResult, _Component);
  return _createClass(SessionItemResult, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.props.makeStyles();
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate() {
      this.props.makeStyles();
    }
  }, {
    key: "points",
    get: function get() {
      var sessionItemResult = this.props.sessionItemResult;
      var normalizedSessionItemResult = sessionItemResult && sessionItemResult.toJS() || {};
      return normalizedSessionItemResult.score;
    }
  }, {
    key: "pointsPresent",
    get: function get() {
      return typeof this.points === 'number';
    }
  }, {
    key: "pointsPossible",
    get: function get() {
      return this.props.sessionItemResult.pointsPossible;
    }
  }, {
    key: "pointsPossiblePresent",
    get: function get() {
      return typeof this.pointsPossible === 'number';
    }
  }, {
    key: "position",
    value: function position() {
      return this.props.sessionItem.position;
    }
  }, {
    key: "unscorable",
    value: function unscorable() {
      return this.props.sessionItemResult.scoredData.get('unscorable');
    }
  }, {
    key: "regraded",
    value: function regraded() {
      return this.props.sessionItemResult.regradeInfo && this.props.sessionItemResult.regradeInfo.get('regraded');
    }
  }, {
    key: "hasRegradeInfo",
    value: function hasRegradeInfo() {
      return this.props.sessionItemResult.regradeInfo && this.props.sessionItemResult.regradeInfo.size > 1;
    }
  }, {
    key: "pointsDisplayText",
    get: function get() {
      var points = this.points;
      var possible = this.pointsPossible;
      if (this.pointsPresent && this.pointsPossiblePresent) {
        return t("{ possible, plural,\n          one   {{points, number} / # point}\n          other {{points, number} / # points}\n        }", {
          points: points,
          possible: possible
        });
      }
      if (this.pointsPossiblePresent) {
        return t("{ possible, plural,\n          one   {# point}\n          other {# points}\n        } possible", {
          possible: possible
        });
      }
      if (this.pointsPresent) {
        return t("{ points, plural,\n          one   {# point}\n          other {# points}\n        } earned", {
          points: points
        });
      }
      return '';
    }
  }, {
    key: "renderRegradeAlert",
    value: function renderRegradeAlert() {
      return jsx(Alert, {
        variant: "warning",
        margin: "medium"
      }, jsx(PresentationContent, null, t('This question has been regraded.')));
    }
  }, {
    key: "renderUnscorableAlert",
    value: function renderUnscorableAlert() {
      // If they can edit grader feedback they should see the teacher message
      var message = this.props.editGraderFeedback ? t('There was a problem grading this question.') : t('There was a problem grading this question. Please inform your instructor.');
      return jsx(Alert, {
        variant: "warning",
        margin: "medium"
      }, jsx(PresentationContent, null, message));
    }
  }, {
    key: "renderRegradePoints",
    value: function renderRegradePoints() {
      return jsx("div", null, jsx(View, {
        as: "span",
        size: "small",
        margin: "small"
      }, jsx(Text, {
        color: "secondary"
      }, t("Previous score { possible, plural,\n              one   {{points, number} / # point}\n              other {{points, number} / # points}\n            }", {
        points: this.props.sessionItemResult.regradeInfo.get('originalScore') || 0,
        possible: this.props.sessionItemResult.regradeInfo.get('originalPointsPossible')
      }))), jsx(View, {
        as: "span",
        size: "small",
        margin: "small"
      }, jsx(Text, {
        color: "alert"
      }, t("Regrade score { possible, plural,\n              one   {{points, number} / # point}\n              other {{points, number} / # points}\n            }", {
        points: this.props.sessionItemResult.regradeInfo.get('newScore') || 0,
        possible: this.props.sessionItemResult.regradeInfo.get('newPointsPossible')
      }))));
    }
  }, {
    key: "renderHeader",
    value: function renderHeader() {
      return jsx("div", {
        css: this.props.styles.sessionItemResultHeader
      }, this.renderResultPosition(), !this.props.restrictQuantitativeData && (this.hasRegradeInfo() ? this.renderRegradePoints() : this.renderPoints()));
    }
  }, {
    key: "renderResultPosition",
    value: function renderResultPosition() {
      var position = this.position();
      var positionText;
      if (this.regraded() && this.unscorable()) {
        positionText = t('Results for question {position, number}. There was a problem grading this question. This question has been regraded.', {
          position: position
        });
      } else if (this.regraded()) {
        positionText = t('Results for question {position, number}. This question has been regraded.', {
          position: position
        });
      } else if (this.unscorable() && this.props.editGraderFeedback) {
        positionText = t('Results for question {position, number}. There was a problem grading this question.', {
          position: position
        });
      } else if (this.unscorable()) {
        positionText = t('Results for question {position, number}. There was a problem grading this question. Please inform your instructor.', {
          position: position
        });
      } else {
        positionText = t('Results for question {position, number}.', {
          position: position
        });
      }
      return jsx(PositionBox, {
        position: position,
        headingLevel: "h3",
        headingText: positionText
      });
    }
  }, {
    key: "renderPoints",
    value: function renderPoints() {
      return jsx("div", {
        css: this.props.styles.points,
        className: "fs-mask"
      }, this.pointsDisplayText);
    }
  }, {
    key: "renderFeedbackBox",
    value: function renderFeedbackBox(feedbackContent, formattedFeedbackTitle) {
      if (feedbackContent) {
        return jsx("div", null, jsx(Heading, {
          level: "h4",
          margin: "xx-small small"
        }, formattedFeedbackTitle), jsx("div", {
          css: this.props.styles.textPadding
        }, jsx(RichContentRenderer, {
          customStyles: this.props.styles.itemFeedbackText,
          content: feedbackContent
        })));
      }
    }
  }, {
    key: "renderItemFeedback",
    value: function renderItemFeedback(simpleSessionItemResult) {
      var itemFeedback = simpleSessionItemResult.feedback && simpleSessionItemResult.feedback.itemFeedback || {};
      var correctFeedback = this.renderFeedbackBox(itemFeedback.correct, t('Based on answering correctly'));
      var incorrectFeedback = this.renderFeedbackBox(itemFeedback.incorrect, t('Based on answering incorrectly'));
      var neutralFeedback = this.renderFeedbackBox(itemFeedback.neutral, t('General Feedback'));
      var graderFeedback = this.renderGraderFeedback(simpleSessionItemResult);
      var answerFeedback = this.renderFeedbackBox(simpleSessionItemResult.answerFeedback, t('Based on your answer'));
      var showAnswerFeedback = this.props.shouldRenderAnswerFeedback && answerFeedback;
      var showFeedback = correctFeedback || incorrectFeedback || neutralFeedback || graderFeedback;
      if (showAnswerFeedback || showFeedback) {
        return jsx("div", {
          css: this.props.styles.itemFeedbackWrapper
        }, jsx(Heading, {
          level: "h3",
          margin: "xx-small small medium"
        }, t('Feedback')), jsx("div", {
          "data-automation": "sdk-answer-feedback-results-view"
        }, this.props.shouldRenderAnswerFeedback && answerFeedback), correctFeedback, incorrectFeedback, neutralFeedback, graderFeedback);
      }
    }
  }, {
    key: "renderGraderFeedback",
    value: function renderGraderFeedback(simpleSessionItemResult) {
      var graderFeedback = simpleSessionItemResult.feedback && simpleSessionItemResult.feedback.graderFeedback || {};
      if (!this.props.hideGraderFeedback && graderFeedback.content) {
        if (this.props.editGraderFeedback) {
          return jsx("div", {
            role: "button",
            onClick: this.props.editGraderFeedback,
            onKeyDown: keyboardClickable,
            css: this.props.styles.itemFeedbackWrapper,
            tabIndex: "0"
          }, jsx("div", {
            css: this.props.styles.itemFeedbackLabel
          }, t('Feedback from grader')), jsx(RichContentRenderer, {
            customStyles: this.props.styles.itemFeedbackText,
            content: graderFeedback.content
          }));
        } else {
          return this.renderFeedbackBox(graderFeedback.content, t('Feedback from grader'));
        }
      }
    }
  }, {
    key: "renderSessionItemResult",
    value: function renderSessionItemResult() {
      var _this$props = this.props,
        appContainer = _this$props.appContainer,
        sessionItem = _this$props.sessionItem,
        sessionItemResult = _this$props.sessionItemResult,
        itemResultsModifications = _this$props.itemResultsModifications;
      if (!sessionItemResult.isLoaded()) {
        return null;
      }
      var item = sessionItem.getItem();
      var slug = item.getInteractionType && item.getInteractionType().slug;
      var ResultInteraction = componentForItem(slug, COMPONENT_RESULT);
      var simpleItem = item.toJS();
      var simpleResultsModifications = itemResultsModifications && itemResultsModifications.toJS() || {};
      var simpleSessionItem = sessionItem.toJS();
      var simpleSessionItemResult = sessionItemResult.toJS();
      return jsx("div", {
        css: this.props.styles.result
      }, jsx("div", {
        css: this.props.styles.question
      }, jsx(ResultInteraction, {
        appContainer: appContainer,
        itemBody: simpleItem.itemBody,
        itemId: simpleSessionItem.id // needed for input group name
        ,
        interactionData: simpleItem.interactionData,
        properties: simpleItem.properties || {},
        scoringData: simpleSessionItem.scoringData,
        scoredData: simpleSessionItemResult.scoredData,
        itemResultsModifications: simpleResultsModifications[simpleSessionItem.id]
      })), this.renderItemFeedback(simpleSessionItemResult));
    }
  }, {
    key: "render",
    value: function render() {
      return jsx("div", {
        css: this.props.styles.sessionItemResult
      }, this.regraded() ? this.renderRegradeAlert() : null, this.unscorable() ? this.renderUnscorableAlert() : null, this.renderHeader(), this.renderSessionItemResult());
    }
  }]);
}(Component), _defineProperty(_SessionItemResult, "displayName", 'SessionItemResult'), _defineProperty(_SessionItemResult, "componentId", "Quizzes".concat(_SessionItemResult.displayName)), _defineProperty(_SessionItemResult, "propTypes", {
  appContainer: CustomPropTypes.selectors.isRequired,
  editGraderFeedback: PropTypes.func,
  hideGraderFeedback: PropTypes.bool,
  itemResultsModifications: ImmutablePropTypes.map,
  restrictQuantitativeData: PropTypes.bool,
  sessionItem: ImmutablePropTypes.record.isRequired,
  sessionItemResult: ImmutablePropTypes.record.isRequired,
  shouldRenderAnswerFeedback: PropTypes.bool,
  shouldRenderTopBorder: PropTypes.bool,
  // used in styles.js
  styles: PropTypes.object,
  makeStyles: PropTypes.func
}), _defineProperty(_SessionItemResult, "defaultProps", {
  editGraderFeedback: null,
  hideGraderFeedback: false,
  itemResultsModifications: null,
  restrictQuantitativeData: false,
  shouldRenderAnswerFeedback: false,
  shouldRenderTopBorder: true
}), _SessionItemResult)) || _class);
export default SessionItemResult;